import CouponUsageQueries from './CouponUsageQueries'

const coupons = {
  coupons: {
    ...CouponUsageQueries,
  }
}

export default coupons